var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 4.96875H11.2969V9.1875H10.5938C9.43064 9.1875 8.48438 10.1338 8.48438 11.2969C8.48438 12.46 9.43064 13.4062 10.5938 13.4062C11.7569 13.4062 12.7031 12.46 12.7031 11.2969C12.7031 10.2336 12.7031 7.97048 12.7031 7.40381C13.117 7.64377 13.5975 7.78125 14.1094 7.78125H15.5156V6.375H14.1094C13.334 6.375 12.7031 5.74416 12.7031 4.96875ZM11.2969 11.2969C11.2969 11.6846 10.9815 12 10.5938 12C10.206 12 9.89062 11.6846 9.89062 11.2969C9.89062 10.9092 10.206 10.5938 10.5938 10.5938H11.2969V11.2969Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 14.8125H5.625V16.2188H18.375V14.8125H21.1875V13.4062H24V4.96875H21.1875V3.5625H18.375V2.15625H5.625V3.5625H2.8125V4.96875H0V13.4062H2.8125V14.8125ZM22.5938 6.375V12H21.1875V6.375H22.5938ZM19.7812 4.96875V13.4062H18.375V4.96875H19.7812ZM7.03125 3.5625H16.9688V14.8125H7.03125V3.5625ZM4.21875 4.96875H5.625V13.4062H4.21875V4.96875ZM1.40625 12V6.375H2.8125V12H1.40625Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.625H1.40625V21.8438H0V17.625Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 17.625H4.21875V21.8438H2.8125V17.625Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.0312H12.5822C12.2919 18.2129 11.5104 17.625 10.5938 17.625C9.67711 17.625 8.89556 18.2129 8.60531 19.0312H5.625V20.4375H8.60531C8.89556 21.2558 9.67711 21.8438 10.5938 21.8438C11.5104 21.8438 12.2919 21.2558 12.5822 20.4375H24V19.0312ZM10.5938 20.4375C10.206 20.4375 9.89062 20.1221 9.89062 19.7344C9.89062 19.3467 10.206 19.0312 10.5938 19.0312C10.9815 19.0312 11.2969 19.3467 11.2969 19.7344C11.2969 20.1221 10.9815 20.4375 10.5938 20.4375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist);
export default __webpack_public_path__ + "static/media/Playlist.3cb3375eefb58941456cca8a8a296cd5.svg";
export { ForwardRef as ReactComponent };